<template>
    <v-container fluid class="d-flex justify-space-around">
         <v-progress-circular
      :size="200"
      :width="15"
      color="primary"
      indeterminate
      class="mt-3"
    ></v-progress-circular>
    </v-container>
</template>
<script>
export default {
    name: 'RedirectHandler',
    data() {
        return {}
    },
    methods: {
        async shopify(id, path) {
            let ids = await this.$store.dispatch('domains/shopifyRedirect', { store: id });
            if(ids) {
                this.$router.push({name: path, params: { domain: ids.domainID, company: ids.companyID, platform: 'shopify' }, query: this.$route.query });
            } else {
                this.$router.push({name: 'home'});
            }
        }
    },
    mounted() {
        let type = this.$route.params.type?.toUpperCase();
        let id = this.$route.params.id;
        let path = this.$route.params.path;
        if(type == 'SHOPIFY') {
            this.shopify(id, path);
        }
    }
}
</script>